/* globals expy */

'use strict';

// TODO: Remove. This is a dummy experiment to test the flow
const expyExperiment = function () {
  return {
    exp_name: 'test_itier_experiment_test',
    exp_type: 'optimizely',
    variants: {
      control: 'variation_1',
      treatment: 'variation_2',
    },
  };
};

module.exports = {
  expyExperiment,
  init() {
    expy.experiment('test_itier_experiment_test');
  },
};
